document.documentElement.classList.remove('no-js');

function initNomadeSection(root) {
  root.querySelectorAll('[data-product-section]').forEach((section) => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const visual = section.querySelector('[data-main-visual]');
    const image = visual?.querySelector('img');
    const classForImage = (src) => {
      if (src.includes('/box-noir-orange.png')) return 'visual-crop crop-noir';
      if (src.includes('/box-blanc-gris.png')) return 'visual-crop crop-blanc';
      return 'visual-native';
    };
    const setImage = (src, className, alt) => {
      if (!visual || !image || !src) return;
      visual.className = `product-visual ${className}`;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
      image.alt = alt;
    };
    section.querySelectorAll('[data-gallery-src]').forEach((button) => {
      button.addEventListener('click', () => {
        setImage(button.dataset.gallerySrc, button.dataset.galleryClass, button.dataset.galleryAlt);
        section.querySelectorAll('[data-gallery-src]').forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb === button)));
      });
    });
    section.querySelectorAll('[data-variant-price]').forEach((input) => {
      input.addEventListener('change', () => {
        section.querySelector('[data-product-price]').textContent = input.dataset.variantPrice;
        section.querySelector('[data-variant-title]').textContent = input.dataset.variantTitle;
        const addButton = section.querySelector('[name="add"]');
        if (addButton) {
          addButton.disabled = false;
          addButton.firstChild.textContent = 'Ajouter au panier ';
        }
        if (input.dataset.variantImage) {
          setImage(input.dataset.variantImage, classForImage(input.dataset.variantImage), input.dataset.variantTitle);
        } else {
          const color = input.dataset.variantColor;
          const thumb = section.querySelector(`[data-gallery-class="visual-crop crop-${color}"]`);
          if (thumb) setImage(thumb.dataset.gallerySrc, thumb.dataset.galleryClass, thumb.dataset.galleryAlt);
        }
        section.querySelectorAll('[data-gallery-src]').forEach((thumb) => thumb.setAttribute('aria-pressed', 'false'));
        if (document.body.classList.contains('template-product')) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url);
        }
      });
    });
    section.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('input');
        const min = Number(input.min || 1);
        input.value = Math.max(min, (Number(input.value) || min) + Number(button.dataset.quantityChange));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
  root.querySelectorAll('.mobile-menu a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details').removeAttribute('open'));
  });
}

initNomadeSection(document);
document.addEventListener('shopify:section:load', () => initNomadeSection(document));
